/**
 * Creation tool font sizes.
 */
enum CreationToolFontSize {
    Small = 'CT_FONT_SIZE_SMALL',
    Medium = 'CT_FONT_SIZE_MEDIUM',
    Large = 'CT_FONT_SIZE_LARGE',
    Autofit = 'CT_FONT_SIZE_AUTOFIT',
}

namespace CreationToolFontSize {
    /**
     * Returns all available font sizes (in order)
     */
    export function all(): CreationToolFontSize[] {
        return [
            CreationToolFontSize.Small,
            CreationToolFontSize.Medium,
            CreationToolFontSize.Large,
            // CreationToolFontSize.Autofit, // TODO: Add support for this in artboard.
        ]
    }

    /**
     * Returns the font size's display title.
     */
    export function title(fontSize: CreationToolFontSize): string {
        switch (fontSize) {
            case CreationToolFontSize.Autofit:
                return 'Autofit'
            case CreationToolFontSize.Small:
                return 'Small'
            case CreationToolFontSize.Medium:
                return 'Medium'
            case CreationToolFontSize.Large:
                return 'Large'
        }
    }

    /**
     * Returns the font size's size (in pixels)
     */
    export function size(fontSize: CreationToolFontSize): number {
        switch (fontSize) {
            case CreationToolFontSize.Small:
                return 24
            case CreationToolFontSize.Large:
                return 48
            default:
                return 34
        }
    }

    /**
     * Returns the font size's scaled size based on height (in percentage)
     * TODO: Delete this and fix caption scaling for real. This is a patch and it sucks.
     */
    export function sizeBaseOnHeight(fontSize: CreationToolFontSize): number {
        const size = CreationToolFontSize.size(fontSize)
        return size / 500
    }
}

export default CreationToolFontSize
